import { List, ListItem, ListItemText } from "@mui/material";
import React from "react";
import db from "./firebase";
import DeleteIcon from "@mui/icons-material/Delete";
import "./ToDo.css"

function ToDo(props) {
  return (
    <List className="list">
      <ListItem className="listitem">
        <ListItemText primary="ToDo" secondary={props.todo.todo} />
      </ListItem>
      
      <DeleteIcon className="delete" onClick={(event) => {
          //for deleting the todo
          db.collection("todos").doc(props.todo.id).delete();
        }}/>
        
    </List>
  );
}

export default ToDo;
